import { ImportDataUploadResultSchema } from "../../models/importDataUploadResult.schema";
import {
  UserDuplicateSchema,
  UserImportDataSchema,
} from "../../models/user.schema";
import { z } from "zod";

export const PrivateImportControllerResponseSchema = {
  uploadCsvFile: z.object({
    file: ImportDataUploadResultSchema,
    headers: z.string().array().nullable(),
    success: z.boolean(),
  }),

  checkForUserImportDuplicates: z.object({
    duplicates: UserDuplicateSchema.array(),
  }),

  importUsersFromFile: z.object({
    previews: UserImportDataSchema.array().optional(),
    importedRecords: z.number(),
    totalRecords: z.number(),
    isPreview: z.boolean(),
  }),
};
